import { render, staticRenderFns } from "./BlowSegments.vue?vue&type=template&id=af8480b6&scoped=true&"
import script from "./BlowSegments.vue?vue&type=script&lang=ts&"
export * from "./BlowSegments.vue?vue&type=script&lang=ts&"
import style0 from "./BlowSegments.vue?vue&type=style&index=0&id=af8480b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8480b6",
  null
  
)

export default component.exports